<template>
  <div class="companyDetail">
    <div class="companyName">
      <a
        class="name"
        :href="
          '/companyDetail?parameter=' +
          _encode({
            company_id: info.company_id,
          })
        "
        target="_blank"
      >
        {{ info.name_en | priorFormat(info.name_zh, LOCALE) }}
      </a>
    </div>
    <div>
      {{ $t("company Size") }}：{{ info.scale | staffSizeFormat(LOCALE) }}
    </div>
    <div>
      {{ $t("companyIndustry") }}：{{
        info.industry | industryFormat(LOCALE) | textFormat
      }}
    </div>
    <div>
      {{ $t("region") }}：{{
        info.company_country
          | countryCityFormat(
            info.company_region_en,
            info.company_region_zh,
            LOCALE
          )
      }}
    </div>
    <div class="clearfix href">
      <div class="fl">{{ $t("website") }}：</div>
      <div
        class="cursor textOverflow fl"
        :class="{ mainColor: info.website }"
        :title="info.website"
      >
        <a
          v-if="info.website && info.website.indexOf('http') != -1"
          :href="info.website"
          target="_blank"
          rel="nofollow"
          >{{ info.website | textFormat }}</a
        >
        <a
          v-else
          :href="'http://' + info.website"
          target="_blank"
          rel="nofollow"
        >
          {{ info.website | textFormat }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import viewPostItem from "~scr/components/booth/viewPostItem";

export default {
  name: "viewPost",
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    viewPostItem,
  },

  methods: {
    to_companyDetai() {
      let routeUrl = this.$router.resolve({
        path: "/companyDetail",
        query: {
          parameter: this._encode({
            company_id: this.info.company_id,
          }),
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    toWebsite() {
      if (this.info.website) window.open(this.info.website);
    },
  },
};
</script>

<style scoped lang="less">
.companyDetail {
  width: 300px;
  padding: 12px 20px 16px;
  background: #ffffff;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.15);
  border-radius: 2px;
  margin-top: 16px;
  .companyName {
    cursor: pointer;
    font-size: 16px;
    font-weight: 500px;
    & > a:hover {
      color: #0083f6;
    }
  }
  .href {
    .mainColor {
      width: 190px;
    }
    a {
      color: #0083f6;
    }
  }
  div {
    line-height: 40px;
  }
}
</style>
